/**
 * Application Entry Point
 * @implements TS-032 - Customer Portal Frontend Package Setup
 *
 * Renders the React application into the DOM.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
